import React, { useState } from "react";
import { IoClose, IoDownload, IoDocument } from "react-icons/io5";

const InvoicePreviewModal = ({ open, files = [], onClose }) => {
  if (!open) return null;

  const downloadFile = (url) => {
    const fileName = url.split("/").pop();
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
      />

      {/* MODAL */}
      <div className="relative w-full max-w-4xl bg-white rounded-xl shadow-xl p-4 z-20 max-h-[90vh] overflow-y-auto">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Invoices</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
            <IoClose className="h-6 w-6 text-gray-700" />
          </button>
        </div>

        {/* PDF LIST AS IMAGE-LIKE THUMBNAILS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {files.map((url, index) => {
            const fileName = url.split("/").pop();

            return (
              <div
                key={index}
                className="border rounded-lg overflow-hidden shadow-sm bg-gray-50 cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => downloadFile(url)}
              >
                {/* THUMBNAIL AREA (SIMULATED AS IMAGE-LIKE) */}
                <div className="flex flex-col items-center justify-center p-4 bg-white border-b">
                  <IoDocument className="h-12 w-12 text-red-500 mb-2" /> {/* PDF Icon as placeholder */}
                  <span className="text-sm font-medium text-center truncate w-full">
                    {fileName}
                  </span>
                </div>

                {/* DOWNLOAD BUTTON (OPTIONAL, SINCE ENTIRE CARD IS CLICKABLE) */}
               {/*  <div className="flex justify-center p-2 bg-gray-50">
                  <IoDownload className="h-5 w-5 text-gray-700 hover:text-red-600" />
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InvoicePreviewModal;
